module.exports = __webpack_public_path__ + "static/js/0.06217ab4.chunk.worker.js"